angular.module('unergie.main')
.directive('copypasta', (AlertManager) =>
    ({
        restrict: 'A',
        templateUrl: '/directives/copypasta/copypasta.html',
        transclude: true,
        scope: {
            copypasta: '=',
        },
        link($scope, element) {
            $scope.copied = function (e) {
                e.preventDefault()
                e.stopPropagation()
                AlertManager.success(`"${$scope.copypasta}" copié !`)
            }
        },
    }),
)
